import React from "react";

const Icon = ({ children, className = "", size = "md", ...props }) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8",
  };

  return (
    <span
      className={`inline-flex items-center justify-center object-contain flex-shrink-0 ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export default Icon;
